export const formatDigits = (num: number, lang: string, noOfDigits?: number) => {
  if (num == null) return '';
  const fractionDigits = noOfDigits ?? 0;
  const formatted = new Intl.NumberFormat(`${lang}-CA`, {
    minimumFractionDigits: fractionDigits,
    maximumFractionDigits: fractionDigits
  }).format(num);
  return formatted;
};
